import React from 'react'
import { required, SelectInput, SelectInputProps } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { useFormContext } from 'react-hook-form'

const defaultProps = {
  label: `${COMMON_FIELDS}.action.label`,
  source: 'action',
  choices: [
    { id: 'none', name: `${COMMON_FIELDS}.action.choices.none` },
    { id: 'link', name: `${COMMON_FIELDS}.action.choices.link` },
  ],
}

export const ActionSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  disabled = false,
  ...props
}) => {
  const { setValue } = useFormContext()

  const actionOnChange = (e): void => {
    const value = e.target.value
    if (value === 'none') {
      setValue('action_type', 1)
    }
  }
  return (
    <SelectInput
      source={source}
      choices={choices}
      label={label}
      disabled={disabled}
      sx={{ marginTop: 0 }}
      fullWidth
      validate={[required()]}
      onChange={actionOnChange}
      {...props}
    />
  )
}

ActionSelectInput.defaultProps = defaultProps
